
import axios from 'axios';
import merge from 'lodash/merge';

const general_axios_options = {
	maxRedirects: 5,
	mode: 'no-cors'
};

export default {

	axios_options: {
		get: {
			...general_axios_options
		},
		post: {
			...general_axios_options
		},
		patch: {
			...general_axios_options
		},
		put: {
			...general_axios_options
		},
		options: {
			...general_axios_options
		},
		delete: {
			...general_axios_options
		}
	},

	doNotices(notices){
		const self = this;

		notices.forEach(notice => {
			self.$store.commit('ADD_NOTICE', notice);
		});

		return true;
	},

	doActions(actions){
		const self = this;

		actions.forEach(action => {
			if(action.type == 'redirect'){
				self.$router.push({ path: action.text });
			}
			if(action.type == 'login'){
				self.$store.commit('LOGOUT');
			}
		});

		return true;
	},

	/**
	 * use:

	this.restget(this.$store.getters.channel.urls.presentation.replace(':id:', 'master'), 'presentation')
		.then(data => {
			self.$store.commit('SET_PRESENTATIONID', self.pid);
			self.data = data;
			self.setupCharts();
			self.setupFields();
		});

	 */
	restget(url, payload, name){
		if(typeof payload == 'string'){
			name = payload;
			payload = undefined;
		}
		const self = this;
		return new Promise((resolve, reject) =>{
			if(self.$store.getters.devmode) console.debug('START restget', url, name);
			if(name !== 'async') self.$store.commit('START_LOADING', name);

			let options = self.axios_options.get;
			if(typeof options !== 'object') options = {};
			if(payload) options.params = payload;

			axios
				.get(url, options)
				.then(self.handleResponse)
				.then(function (response) {
					if(self.$store.getters.devmode) console.debug('FINISH restget', url, name);
					if(response.data.notices && typeof self.doNotices == 'function') {
						self.doNotices(response.data.notices)
					}
					if(response.data.actions && typeof self.doActions == 'function') {
						self.doActions(response.data.actions)
					}

					if(name !== 'async') self.$store.commit('END_LOADING', name);

					resolve(response.data.message);
				})
				.catch(function (error) {
					self.$store.commit('ADD_ERROR', error);
					reject(error);
				});
		});
	},

	/**
	 * use:

	this.restpatch(this.$store.getters.channel.urls.presentation.replace(':id:', 'master'), {}, 'presentation')
		.then(data => {
			self.$store.commit('SET_PRESENTATIONID', self.pid);
			self.data = data;
			self.setupCharts();
			self.setupFields();
		});

	 */
	restpatch(url, payload, name){
		const self = this;
		return new Promise((resolve, reject) =>{
			if(self.$store.getters.devmode) console.debug('START restpatch', url, name);
			self.$store.commit('START_SAVEING', name);
			axios
				.patch(url, payload, self.axios_options.patch)
				.then(function (response) {
					if(self.$store.getters.devmode) console.debug('FINISH restpatch', url, name);
					if(response.data.notices && typeof self.doNotices == 'function') {
						self.doNotices(response.data.notices)
					}
					if(response.data.actions && typeof self.doActions == 'function') {
						self.doActions(response.data.actions)
					}

					self.$store.commit('END_SAVEING', name);

					resolve(response.data.message);
				})
				.catch(function (error) {
					self.$store.commit('ADD_ERROR', error);
					self.$store.commit('END_SAVEING', name);
					reject(error);
				});
		});
	},
	/**
	 * use:

	this.restput(this.$store.getters.channel.urls.presentation.replace(':id:', 'master'), {}, 'presentation')
		.then(data => {
			self.$store.commit('SET_PRESENTATIONID', self.pid);
			self.data = data;
			self.setupCharts();
			self.setupFields();
		});

	 */
	restput(url, payload, name){
		const self = this;
		return new Promise((resolve, reject) =>{
			if(self.$store.getters.devmode) console.debug('START restput', url, name);
			self.$store.commit('START_SAVEING', name);
			axios
				.put(url, payload, self.axios_options.put)
				.then(function (response) {
					if(self.$store.getters.devmode) console.debug('FINISH restput', url, name);
					if(response.data.notices && typeof self.doNotices == 'function') {
						self.doNotices(response.data.notices)
					}
					if(response.data.actions && typeof self.doActions == 'function') {
						self.doActions(response.data.actions)
					}

					self.$store.commit('END_SAVEING', name);

					resolve(response.data.message);
				})
				.catch(function (error) {
					self.$store.commit('ADD_ERROR', error);
					self.$store.commit('END_SAVEING', name);
					reject(error);
				});
		});
	},

	/**
	 * use:

	this.restpost(this.$store.getters.channel.urls.presentation.replace(':id:', 'master'), {}, 'presentation')
		.then(data => {
			self.$store.commit('SET_PRESENTATIONID', self.pid);
			self.data = data;
			self.setupCharts();
			self.setupFields();
		});

	 */
	restpost(url, payload, name){
		const self = this;
		return new Promise((resolve, reject) =>{
			if(self.$store.getters.devmode) console.debug('START restpost', url, name);
			self.$store.commit('START_SAVEING', name);
			axios
				.post(url, payload, self.axios_options.post)
				.then(function (response) {
					if(self.$store.getters.devmode) console.debug('FINISH restpost', url, name);
					if(response.data.notices && typeof self.doNotices == 'function') {
						self.doNotices(response.data.notices)
					}
					if(response.data.actions && typeof self.doActions == 'function') {
						self.doActions(response.data.actions)
					}

					self.$store.commit('END_SAVEING', name);

					resolve(response.data.message);
				})
				.catch(function (error) {
					self.$store.commit('ADD_ERROR', error);
					self.$store.commit('END_SAVEING', name);
					reject(error);
				});
		});
	},





	/**
	 * use:

	this.restdelete(this.$store.getters.channel.urls.presentation.replace(':id:', 'master'), 'presentation')
		.then(data => {
			self.$store.commit('SET_PRESENTATIONID', self.pid);
			self.data = data;
			self.setupCharts();
			self.setupFields();
		});

	 */
	restdelete(url, payload, name){
		if(typeof payload == 'string'){
			name = payload;
			payload = undefined;
		}
		const self = this;
		return new Promise((resolve, reject) =>{
			if(self.$store.getters.devmode) console.debug('START restdelete', url, name);
			self.$store.commit('START_SAVEING', name);

			let options = self.axios_options.delete;
			if(typeof options !== 'object') options = {};
			if(payload) options.params = payload;

			axios
				.delete(url, options)
				.then(function (response) {
					if(self.$store.getters.devmode) console.debug('FINISH restdelete', url, name);
					if(response.data.notices && typeof self.doNotices == 'function') {
						self.doNotices(response.data.notices)
					}
					if(response.data.actions && typeof self.doActions == 'function') {
						self.doActions(response.data.actions)
					}

					self.$store.commit('END_SAVEING', name);

					resolve(response.data.message);
				})
				.catch(function (error) {
					self.$store.commit('ADD_ERROR', error);
					self.$store.commit('END_SAVEING', name);
					reject(error);
				});
		});
	},

	/**
	 * use:

	this.restoptions(this.$store.getters.channel.urls.presentation.replace(':id:', 'master'), {}, 'presentation')
		.then(data => {
			self.$store.commit('SET_PRESENTATIONID', self.pid);
			self.data = data;
			self.setupCharts();
			self.setupFields();
		});

	 */
	restoptions(url, payload, name){
		if(typeof payload == 'string'){
			name = payload;
			payload = undefined;
		}
		const self = this;
		return new Promise((resolve, reject) =>{
			if(self.$store.getters.devmode) console.debug('START restoptions', url, name);
			self.$store.commit('START_LOADING', name);
			if(self.$store.getters.devmode) console.debug('OPTIONS REQUEST START', url);

			let options = self.axios_options.options;
			if(typeof options !== 'object') options = {};
			if(payload) options.params = payload;

			axios
				.options(url, options)
				.then(function (response) {
					if(self.$store.getters.devmode) console.debug('FINISH restoptions', url, name);
					if(self.$store.getters.devmode) console.debug('OPTIONS REQUEST FINISHED', url);
					if(response.data.notices && typeof self.doNotices == 'function') {
						self.doNotices(response.data.notices)
					}
					if(response.data.actions && typeof self.doActions == 'function') {
						self.doActions(response.data.actions)
					}

					self.$store.commit('END_LOADING', name);

					resolve(response.data.message);
				})
				.catch(function (error) {
					self.$store.commit('ADD_ERROR', error);
					self.$store.commit('END_SAVEING', name);
					reject(error);
				});
		});
	},

};



// WEBPACK FOOTER //
// ./src/helpers/rest.js